module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-13-0a022d01e4b5a38a3c06a6b106b384f5.jpg";